import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import { Globals } from "../../globals";
import { DishServices } from '../dish/services';
import { IngredientsServices } from '../ingredients/services';
import { ProvidersServices } from '../providers/services';
import { ProductsServices } from '../products/services';
import { MenuServices } from '../menu/services';
import { ConfigurationServices } from '../configuration/services';
import { LoadingController } from 'ionic-angular';
import { CartaServices } from '../carta/services';
import { TranslateService } from '@ngx-translate/core';

/*
* Jerarquia static:
* 0 - Provider
* 1 - Ingredients Basic
* 2 - Ingredient sub recipe
* 3 - Dish / Ingredient sub recipe que contiene Ingredient sub recipe / Product with foodcost
* 3 - Menu / Cart / Products Basic
*
* Productos con escandallo no esta porque no tien niveles a bajo.
* */

@Injectable()

export class StaticsServices {

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public dishServices: DishServices,
    public ingredientsServices: IngredientsServices,
    public providersServices: ProvidersServices,
    public productsServices: ProductsServices,
    public menuServices: MenuServices,
    public configurationServices: ConfigurationServices,
    public loadingCtrl: LoadingController,
    public cartaServices: CartaServices,
    public translate: TranslateService) {
  }


  //update static_wait true
  changeStateStaticWait(state) {
    this.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'static_wait': state,
    }).then(() => {
      this.globals.restaurant.static_wait = state;
    });



  }

  //delete insert in _queue
  addDeleteStaticToQueue(uid_element, delete_static_type) {
    this.afs.collection('_queue').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'type': 'delete_static',
      'delete_static_type': delete_static_type,
      'uid_element': uid_element,
    }).then(doc => { });
  }

  /*UPDATES*/

  async updateStaticsFinishDish() {
    this.presentLoading();
    await this.updateMenuStatics();
    await this.updateCartaStatics();
    this.dissmisLoading();
  }

  async updateStaticsFinishIngrBasic_IngrSubRecipe() {
    this.presentLoading();
    await this.updateIngredientSubStatics();
    await this.updateProductStatics();
    await this.updateDishStatics();
    await this.updateStaticsFinishDish();
    this.dissmisLoading();
  }

  async updateProvidersFinish() {
    this.presentLoading();
    await this.updateProviderStatics();
    await this.updateStaticsFinishIngrBasic_IngrSubRecipe();
    this.dissmisLoading();
  }

  async updateProviderStatics() {
    await this.loaderProviderStatics();
    await this.updateProvidersIngredients();
    await this.updateProvidersProducts();
  }

  public ingredients: any;
  public products: any;
  public productsSub: any;
  public providers: any;
  async loaderProviderStatics() {
    this.ingredients = await this.ingredientsServices.getIngredientsBasic(this.globals.restaurant_uid);
    this.products = await this.productsServices.getProductsBasic(this.globals.restaurant_uid);
    this.providers = await this.providersServices.getProviders(this.globals.restaurant_uid);
  }

  changeFormatDate(date) {
    var split = date.split("/");
    var return_date = split[1] + '/' + split[0] + '/' + split[2];
    return return_date
  }

  async updateProvidersIngredients() {
    //previamente hemos cargado los ingredientes
    for (let ingredient of this.ingredients) {
      if (ingredient.providers) {
        for (let provider of ingredient.providers) {
          //buscamos el proveedor del ingrediente en la lista de proveedores
          var _provider = this.providers.find(e => e.UID === provider.uid);
          if (_provider) {
            if (provider.updated_at < _provider.updated_at) {
              provider.name_static = _provider.name;
              provider.updated_at = new Date();
              if (provider.default) {
                ingredient.provider_static = _provider.name;
              }
            }
          }
        }
        //update en firebase
        this.ingredientsServices.afs.collection('ingredients').doc(ingredient.UID).update({
          'provider_static': ingredient.provider_static,
          'providers': ingredient.providers,
          'updated_at': new Date(),
        }).then(() => { })
      }

    }
  }

  async updateProvidersProducts() {
    //previamente hemos cargado los productos
    for (let product of this.products) {
      if (product.providers) {
        for (let provider of product.providers) {
          //buscamos el proveedor del producto en la lista de proveedores
          var _provider = this.providers.find(e => e.UID === provider.uid);
          if (_provider) {
            if (provider.updated_at < _provider.updated_at) {
              provider.name_static = _provider.name;
              provider.updated_at = new Date();
              if (provider.default) {
                product.provider_static = _provider.name;
              }
            }
          }
        }
        //update en firebase
        this.productsServices.afs.collection('products').doc(product.UID).update({
          'provider_static': product.provider_static,
          'providers': product.providers,
          'updated_at': new Date(),
        }).then(() => { });
      }

    }

  }

  public ingredientsSub: any;
  public ingredientsSubIncludeSub: any;
  async loaderIngredientSubStatics() {
    this.ingredientsSub = await this.ingredientsServices.getIngredientsSubNoIncludeSubrecipe(this.globals.restaurant_uid);
    this.ingredients = await this.ingredientsServices.getIngredients(this.globals.restaurant_uid);
    this.ingredientsSubIncludeSub = await this.ingredientsServices.getIngredientsSubIncludeSubrecipe(this.globals.restaurant_uid);
  }

  async updateIngredientSubStatics() {
    await this.loaderIngredientSubStatics();
    await this.updateIngredientSubNoIncludeSub();
    await this.loaderIngredientSubStatics();
    await this.updateIngredientSubIncludeSub();
  }

  async updateIngredientSubNoIncludeSub() {
    //previamente hemos cargado los ingredientes con subrecetas sin ingredientes subrecetas
    for (let ingredientSub of this.ingredientsSub) {
      var _foodcost_static = 0;
      for (let ing of ingredientSub.foodcost) {
        //buscamos el ingrediente del ingredientesub en la lista de ingredientes
        var ingredient = this.ingredients.find(e => e.UID === ing.uid);
        if (ingredient) {
          if (ing.updated_at < ingredient.updated_at) {
            if (ingredient.sub_recipe) {
              ing.price_notax = this.ingredientsServices.returnPricePerMeasurement(ingredient.price_static, ingredient.real_weight);
            } else {
              ing.price_notax = ingredient.price_static;
            }
            ing.name_static = ingredient.name;
            ing.provider_static = ingredient.provider_static;
            ing.measurement_static = this.ingredientsServices.measurementLite(ingredient.measurement);
            var _pricetotal_static = this.ingredientsServices.calculatePrice(ing.price_notax, ing.quantity_gross, ingredient.measurement);
            ing.updated_at = new Date();
            if (ingredient.sub_recipe) {
              ing.price_static = this.ingredientsServices.returnPricePerMeasurement(_pricetotal_static, ingredient.real_weight);
            } else {
              ing.price_static = _pricetotal_static;
            }
          }
        }
        //Suma el coste total del foodcost. De todos los ingredientes del plato
        _foodcost_static += ing.price_static;
      }
      //update ingredientSub
      this.ingredientsServices.afs.collection('ingredients').doc(ingredientSub.UID).update({
        'foodcost': ingredientSub.foodcost,
        'price_static': _foodcost_static,
        'updated_at': new Date(),
      }).then(() => {
      });
    }
  }



  async updateIngredientSubIncludeSub() {
    //previamente hemos cargado los ingredientes con subrecetas con ingredientes subrecetas
    for (let ingredientSubIncludeSub of this.ingredientsSubIncludeSub) {
      var _foodcost_static = 0;
      for (let ing of ingredientSubIncludeSub.foodcost) {
        //buscamos el ingredientesub del ingrediente/ub en la lista de ingredientes
        var ingredient = this.ingredients.find(e => e.UID === ing.uid);
        if (ingredient) {
          if (ing.updated_at < ingredient.updated_at) {
            if (ingredient.sub_recipe) {
              ing.price_notax = this.ingredientsServices.returnPricePerMeasurement(ingredient.price_static, ingredient.real_weight);
            } else {
              ing.price_notax = ingredient.price_static;
            }
            ing.name_static = ingredient.name;
            ing.provider_static = ingredient.provider_static;
            ing.measurement_static = this.ingredientsServices.measurementLite(ingredient.measurement);
            var _pricetotal_static = this.ingredientsServices.calculatePrice(ing.price_notax, ing.quantity_gross, ingredient.measurement);
            ing.updated_at = new Date();
            ing.price_static = _pricetotal_static;

          }
        }
        _foodcost_static += ing.price_static;
      }
      //update ingredientSubIncludeSub
      this.ingredientsServices.afs.collection('ingredients').doc(ingredientSubIncludeSub.UID).update({
        'foodcost': ingredientSubIncludeSub.foodcost,
        'price_static': _foodcost_static,
        'updated_at': new Date(),
      }).then(() => {
      });

    }
  }


  async loaderProducts() {
    this.productsSub = await this.productsServices.getProductsCompost(this.globals.restaurant_uid);
    this.ingredients = await this.ingredientsServices.getIngredients(this.globals.restaurant_uid);
  }


  async updateProductStatics() {
    //llamar a loader
    await this.loaderProducts();
    //previamente hemos cargado los platos usando el loader
    for (let productSub of this.productsSub) {
      var _foodcost_static = 0;
      for (let _product_ingr_foodcost of productSub.foodcost) {
        //buscamos el ingrediente del plato en la lista de ingredientes
        var ingredient = this.ingredients.find(e => e.UID === _product_ingr_foodcost.uid);
        //buscamos que el campo no este vacio

        if (ingredient) {
          if (_product_ingr_foodcost.updated_at < ingredient.updated_at) {
            //Comprovamos que el ingrediente este actulizado en una fecha mayor que el ingrediente del plato (ejemplo: 20/09/19 (Mayor que) 16/09/19)

            _product_ingr_foodcost.name_static = ingredient.name;
            _product_ingr_foodcost.measurement_static = this.ingredientsServices.measurementLite(ingredient.measurement);//cambia de kg a gr

            _product_ingr_foodcost.price_static = this.ingredientsServices.calculatePrice(ingredient.price_static, _product_ingr_foodcost.quantity_gross, ingredient.measurement);//recalcular el precio del elemento a actualizar
            _product_ingr_foodcost.price_notax = ingredient.price_static;//precio sin iva del coste del ingrediente

            _product_ingr_foodcost.provider_static = ingredient.provider_static;// proveedor del ingrediente
            _product_ingr_foodcost.updated_at = new Date();
          }
        }

        //Suma el coste total del foodcost. De todos los ingredientes del producto
        _foodcost_static += _product_ingr_foodcost.price_static;

      }
      //update dish
      this.dishServices.afs.collection('products').doc(productSub.UID).update({
        'foodcost': productSub.foodcost,
        'price_static': _foodcost_static,
        'updated_at': new Date(),
      }).then(() => {

      });
    }
  }

  public dishes: any;
  async loaderDish() {
    this.dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);
    this.ingredients = await this.ingredientsServices.getIngredients(this.globals.restaurant_uid);
  }

  async updateDishStatics() {
    //llamar a loader
    await this.loaderDish();
    //previamente hemos cargado los platos usando el loader
    for (let dish of this.dishes) {
      var _foodcost_static = 0;
      if (dish.foodcost) {
        for (let _dish_ingr_foodcost of dish.foodcost) {
          //buscamos el ingrediente del plato en la lista de ingredientes
          var ingredient = this.ingredients.find(e => e.UID === _dish_ingr_foodcost.uid);
          //buscamos que el campo no este vacio

          if (ingredient) {
            if (_dish_ingr_foodcost.updated_at < ingredient.updated_at) {
              //Comprovamos que el ingrediente este actulizado en una fecha mayor que el ingrediente del plato (ejemplo: 20/09/19 (Mayor que) 16/09/19)
              if (ingredient.sub_recipe) {
                _dish_ingr_foodcost.price_static = this.ingredientsServices.returnPricePerMeasurement(ingredient.price_static, ingredient.real_weight);
              } else {
                _dish_ingr_foodcost.price_static = ingredient.price_static;
              }
              _dish_ingr_foodcost.name_static = ingredient.name;
              _dish_ingr_foodcost.measurement_static = ingredient.measurement;
              var _pricetotal_static = this.ingredientsServices.calculatePrice(_dish_ingr_foodcost.price_static, _dish_ingr_foodcost.quantity_gross, _dish_ingr_foodcost.measurement_static);
              _dish_ingr_foodcost.pricetotal_static = _pricetotal_static;
              _dish_ingr_foodcost.provider_static = ingredient.provider_static;

              _dish_ingr_foodcost.updated_at = new Date();

            }
          }

          //Suma el coste total del foodcost. De todos los ingredientes del plato
          _foodcost_static += _dish_ingr_foodcost.pricetotal_static;
        }
        //update dish
        this.dishServices.afs.collection('dish').doc(dish.UID).update({
          'foodcost': dish.foodcost,
          'foodcost_static': _foodcost_static,
          'updated_at': new Date(),
        }).then(() => {
          //dataset
          this.globals.dataSet('plat_cost', _foodcost_static, '', dish.name_es, '');
        });
      }

    }
  }


  public sumands: number = 0;
  public count_tmp: number = 0;
  public menu_cost: number = 0;
  public menus: any;
  async loaderMenus() {
    this.menus = await this.menuServices.getMenus(this.globals.restaurant_uid);
    this.dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);
  }


  async updateMenuStatics() {
    //llamar a loader
    await this.loaderMenus();
    //previamente hemos cargado los menus usando el loader
    for (let menu of this.menus) {
      if (menu.sections != undefined) {//mirar que campo secciones exista
        for (var i = 0; Object.keys(menu.sections).length > i; i++) {//recorer secciones
          for (var j = 0; Object.keys(menu.sections[i].dish).length > j; j++) {//recorer platos
            //buscamos el plato de la seccion del menu
            var dish = this.dishes.find(e => e.UID === menu.sections[i].dish[j].uid);//buscar el plato actualizado

            if (dish) {
              menu.sections[i].dish[j].name = dish.name_es;
              menu.sections[i].dish[j].name_ca = dish.name_ca;
              menu.sections[i].dish[j].name_en = dish.name_en;
              menu.sections[i].dish[j].name_fr = dish.name_fr;
              menu.sections[i].dish[j].name_de = dish.name_de;
              menu.sections[i].dish[j].name_it = dish.name_it;

              if (dish.foodcost_parts != undefined) {//que foodcost_parts de plato exista
                menu.sections[i].dish[j].foodcost_parts = parseFloat(dish.foodcost_parts);
              }
              if (dish.foodcost_static != undefined) {//que foodcost_static de plato exista
                menu.sections[i].dish[j].foodcost_static = parseFloat(dish.foodcost_static);
              }
              if (dish.allergens != undefined) {//que allergens de plato exista
                menu.sections[i].dish[j].allergens = dish.allergens;
              } else {
                menu.sections[i].dish[j].allergens = [];
              }
            }

          }
        }

        //actualizar menu
        this.menuServices.afs.collection('menus').doc(menu.UID).update({
          'sections': menu.sections,
        }).then(() => { });
      }
      this.updateMenuCost(menu.UID); //recalcular el coste del menu
    }
  }

  async updateMenuCost(menu_uid) {
    //init vars
    var all_dishs_foodcost = true; // Utilizamos para controlar si tiene foodcost todo el menu
    var menu_cost = 0;
    var total_dishes = 0;
    var total_sections = 0;
    var average_foodcost = 0;
    //get menu
    var menu = await this.menuServices.getMenu(menu_uid);//recuperamos el menu actualizado

    if (menu.sections != undefined) {//mirar que campo secciones del menu exista
      for (let section of this.globals.objectToArray(menu.sections)) {//recorer secciones
        //init vars per section
        var average_section = 0;
        var count_section = 0;
        //recorer platos
        for (let dish of this.globals.objectToArray(section.dish)) {
          total_dishes++;
          //buscamos el plato de la seccion del menu
          if (parseFloat(dish.foodcost_parts) > 0 && parseFloat(dish.foodcost_static) > 0) {//que foodcost_parts y foodcost_static sean mayor de 0 para poder recalcular
            //calculamos el coste del elemento
            average_section += parseFloat(dish.foodcost_static) / parseFloat(dish.foodcost_parts);
            count_section++;
          } else {
            all_dishs_foodcost = false;//caso no tenga foodcost
          }
        }
        //calculamos la media de la seccion y sumamos
        if (!isNaN((average_section / count_section)) && !section.combo_input_text) {
          average_foodcost += (average_section / count_section);
        }
        total_sections++;
      }
      //calculo del coste
      menu_cost = average_foodcost;
      if (menu.extra) { //Comprovamos que el menu tenga extra aunque sea 0
        menu_cost = menu_cost + parseFloat(menu.extra);
      }

    } else {//si no secciones no podemos calcular coste
      menu_cost = 0;
    }

    if (!all_dishs_foodcost) { // Si no foodcost ponemos menu cost a 0
      menu_cost = 0;
    }

    //actualizamos menu
    this.menuServices.afs.collection('menus').doc(menu_uid).update({
      'menu_cost': menu_cost,
    }).then(() => {
      //prepare extra
      var extra: any =
      {
        'tax': this.globals.user_tax,
        'cost': menu_cost,
        'cost_extra': menu.extra,
        'extras_menu': menu.extras_footer,
        'total_sections': total_sections,
        'total_dishes': total_dishes,
      };

      this.globals.dataSet('menu_price', menu.price, '', JSON.stringify(extra), '');

    });

  }

  cartas: any;
  async loaderCartas() {
    this.cartas = await this.cartaServices.getCartas(this.globals.restaurant_uid);
    this.products = await this.productsServices.getProducts(this.globals.restaurant_uid);
    this.dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);
  }

  async updateCartaStatics() {
    //llamar a loader
    await this.loaderCartas();
    //previamente hemos cargado los menus usando el loader
    for (let carta of this.cartas) {

      if (carta.pages != undefined) {//mirar que exista el campo pages
        for (var i = 0; Object.keys(carta.pages).length > i; i++) {//recorer paginas
          for (var j = 0; Object.keys(carta.pages[i].sections).length > j; j++) {//recorer secciones
            for (var h = 0; Object.keys(carta.pages[i].sections[j].elements).length > h; h++) {//recorer elementos
              if (carta.pages[i].sections[j].elements[h].type == 'dish') {//si plato
                var dish = this.dishes.find(e => e.UID === carta.pages[i].sections[j].elements[h].uid);//buscar el plato actualizado

                if (dish) {
                  //name
                  if (dish.name_es != undefined) {
                    carta.pages[i].sections[j].elements[h].name_es = dish.name_es;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_es = "";
                  }
                  if (dish.name_ca != undefined) {
                    carta.pages[i].sections[j].elements[h].name_ca = dish.name_ca;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_ca = "";
                  }
                  if (dish.name_en != undefined) {
                    carta.pages[i].sections[j].elements[h].name_en = dish.name_en;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_en = "";
                  }
                  if (dish.name_fr != undefined) {
                    carta.pages[i].sections[j].elements[h].name_fr = dish.name_fr;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_fr = "";
                  }
                  if (dish.name_de != undefined) {
                    carta.pages[i].sections[j].elements[h].name_de = dish.name_de;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_de = "";
                  }
                  if (dish.name_it != undefined) {
                    carta.pages[i].sections[j].elements[h].name_it = dish.name_it;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_it = "";
                  }
                  //description
                  if (dish.description_es != undefined) {
                    carta.pages[i].sections[j].elements[h].description_es = dish.description_es;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_es = "";
                  }
                  if (dish.description_ca != undefined) {
                    carta.pages[i].sections[j].elements[h].description_ca = dish.description_ca;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_ca = "";
                  }
                  if (dish.description_en != undefined) {
                    carta.pages[i].sections[j].elements[h].description_en = dish.description_en;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_en = "";
                  }
                  if (dish.description_fr != undefined) {
                    carta.pages[i].sections[j].elements[h].description_fr = dish.description_fr;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_fr = "";
                  }
                  if (dish.description_de != undefined) {
                    carta.pages[i].sections[j].elements[h].description_de = dish.description_de;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_de = "";
                  }
                  if (dish.description_it != undefined) {
                    carta.pages[i].sections[j].elements[h].description_it = dish.description_it;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_it = "";
                  }
                  //
                  carta.pages[i].sections[j].elements[h].price = dish.price;
                  carta.pages[i].sections[j].elements[h].price_half = dish.price_half;
                  carta.pages[i].sections[j].elements[h].price_tapa = dish.price_tapa;
                  carta.pages[i].sections[j].elements[h].cost_ration = dish.foodcost_static / parseFloat(dish.foodcost_parts);

                  if (carta.pages[i].sections[j].elements[h].allergens != undefined) {//que allergens de plato exista
                    carta.pages[i].sections[j].elements[h].allergens = dish.allergens;
                  } else {
                    carta.pages[i].sections[j].elements[h].allergens = [];
                  }
                  if (dish.image != undefined) {
                    carta.pages[i].sections[j].elements[h].image = dish.image;
                  } else {
                    carta.pages[i].sections[j].elements[h].image = "";
                  }
                }

              } else if (carta.pages[i].sections[j].elements[h].type == 'product') {//si producto
                var product = this.products.find(e => e.UID === carta.pages[i].sections[j].elements[h].uid);//buscar el producto actualizado

                if (product) {
                  //name
                  if (product.name != undefined) {
                    carta.pages[i].sections[j].elements[h].name_es = product.name;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_es = "";
                  }
                  if (product.name_ca != undefined) {
                    carta.pages[i].sections[j].elements[h].name_ca = product.name_ca;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_ca = "";
                  }
                  if (product.name_en != undefined) {
                    carta.pages[i].sections[j].elements[h].name_en = product.name_en;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_en = "";
                  }
                  if (product.name_fr != undefined) {
                    carta.pages[i].sections[j].elements[h].name_fr = product.name_fr;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_fr = "";
                  }
                  if (product.name_de != undefined) {
                    carta.pages[i].sections[j].elements[h].name_de = product.name_de;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_de = "";
                  }
                  if (product.name_it != undefined) {
                    carta.pages[i].sections[j].elements[h].name_it = product.name_it;
                  } else {
                    carta.pages[i].sections[j].elements[h].name_it = "";
                  }
                  //description
                  if (product.description_es != undefined) {
                    carta.pages[i].sections[j].elements[h].description_es = product.description_es;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_es = "";
                  }
                  if (product.description_ca != undefined) {
                    carta.pages[i].sections[j].elements[h].description_ca = product.description_ca;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_ca = "";
                  }
                  if (product.description_en != undefined) {
                    carta.pages[i].sections[j].elements[h].description_en = product.description_en;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_en = "";
                  }
                  if (product.description_fr != undefined) {
                    carta.pages[i].sections[j].elements[h].description_fr = product.description_fr;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_fr = "";
                  }
                  if (product.description_de != undefined) {
                    carta.pages[i].sections[j].elements[h].description_de = product.description_de;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_de = "";
                  }
                  if (product.description_it != undefined) {
                    carta.pages[i].sections[j].elements[h].description_it = product.description_it;
                  } else {
                    carta.pages[i].sections[j].elements[h].description_it = "";
                  }
                  //
                  if (product.image != undefined) {
                    carta.pages[i].sections[j].elements[h].image = product.image;
                  } else {
                    carta.pages[i].sections[j].elements[h].image = "";
                  }
                  carta.pages[i].sections[j].elements[h].price = product.pvp;
                  carta.pages[i].sections[j].elements[h].price_half = "";
                  carta.pages[i].sections[j].elements[h].price_tapa = "";
                  carta.pages[i].sections[j].elements[h].cost_ration = product.price_static;
                  if (carta.pages[i].sections[j].elements[h].allergens != undefined) {//que allergens de producto exista
                    carta.pages[i].sections[j].elements[h].allergens = product.allergens;
                  } else {
                    carta.pages[i].sections[j].elements[h].allergens = [];
                  }

                }
              }
            }
          }
        }
        //actualizar carta
        this.cartaServices.afs.collection('cartas').doc(carta.UID).update({
          'pages': carta.pages,
        }).then(() => {
        });
      }
    }
  }

  /*END UPDATES*/

  /*DELTES*/

  //INGS
  async deletesIngUpdate(uid) {
    this.presentLoading();
    var uid_element = uid;
    await this.deletesInDishs(uid_element);
    await this.deletesInIngComp(uid_element);
    await this.deletesInProdComp(uid_element);
    await this.deletesInVariations(uid_element);
    await this.updateStaticsFinishIngrBasic_IngrSubRecipe();
    this.dissmisLoading();
  }
  //PRODS
  async deletesProdUpdate(uid) {
    this.presentLoading();
    var uid_element = uid;
    await this.deletesInVariations(uid_element);
    await this.deletesInCartas(uid_element);
    await this.updateCartaStatics();
    this.dissmisLoading();
  }

  //DISHES
  async deletesDishUpdate(uid) {
    var uid_element = uid;
    this.presentLoading();
    await this.deletesInMenu(uid_element);
    await this.deletesInVariations(uid_element);
    await this.deletesInCartas(uid_element);
    this.updateStaticsFinishDish();
    this.dissmisLoading();
  }

  //PROVIDERS
  async deleteProviderUpdate(uid) {
    var uid_element = uid;
    this.presentLoading();
    await this.deletesInIngredients(uid_element);
    await this.deletesInProducts(uid_element);
    await this.updateProvidersFinish();
    this.dissmisLoading();
  }



  //FUNCS
  async deletesInDishs(uid) {
    var dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);

    for (let dish of dishes) {
      const index = dish.foodcost.findIndex(ing => ing.uid === uid);

      if (index >= 0) {
        dish.foodcost.splice(index, 1);
        //update dish
        this.dishServices.afs.collection('dish').doc(dish.UID).update({
          'foodcost': dish.foodcost,
        }).then(() => {
        });
      }

    }
  }

  async deletesInIngComp(uid) {
    var ingredients = await this.ingredientsServices.getIngredientsCompostos(this.globals.restaurant_uid);

    for (let ingredient of ingredients) {
      const index = ingredient.foodcost.findIndex(ing => ing.uid === uid);
      if (index >= 0) {
        ingredient.foodcost.splice(index, 1);
        //update dish
        this.dishServices.afs.collection('ingredients').doc(ingredient.UID).update({
          'foodcost': ingredient.foodcost,
        }).then(() => {
        });
      }
    }

  }

  async deletesInProdComp(uid) {
    var products = await this.productsServices.getProductsCompost(this.globals.restaurant_uid);

    for (let product of products) {
      const index = product.foodcost.findIndex(ing => ing.uid === uid);
      if (index >= 0) {
        product.foodcost.splice(index, 1);
        //update dish
        this.dishServices.afs.collection('products').doc(product.UID).update({
          'foodcost': product.foodcost,
        }).then(() => {
        });
      }
    }
  }

  async deletesInVariations(uid) {
    var variations = await this.configurationServices.getAllVariations(this.globals.restaurant_uid);

    for (let variation of variations) {
      if (variation.uid_element == uid) {
        this.configurationServices.afs.doc('variations/' + variation.UID).delete();
      }
    }

  }

  async deletesInMenu(uid) {
    var menus = await this.menuServices.getMenus(this.globals.restaurant_uid);

    for (let menu of menus) {
      if (menu.sections != undefined) {
        for (let section of this.globals.objectToArray(menu.sections)) {
          var _dish = this.globals.objectToArray(section.dish);
          const index = _dish.findIndex(doc => doc.uid === uid);

          if (index != -1) {
            _dish.splice(index, 1);
          }

          section.dish = _dish;
        }
        this.menuServices.afs.collection('menus').doc(menu.UID).update({
          'sections': menu.sections,
        }).then(() => {
        });
      }
    }
  }

  async deletesInCartas(uid) {
    var cartas = await this.cartaServices.getCartas(this.globals.restaurant_uid);

    for (let carta of cartas) {
      if (carta.pages != undefined) {
        for (let page of this.globals.objectToArray(carta.pages)) {
          for (let section of this.globals.objectToArray(page.sections)) {

            var _elements = this.globals.objectToArray(section.elements);
            const index = _elements.findIndex(doc => doc.uid === uid);

            if (index != -1) {
              _elements.splice(index, 1);
            }

            section.elements = _elements;

          }
        }
        this.cartaServices.afs.collection('cartas').doc(carta.UID).update({
          'pages': carta.pages,
        }).then(() => { });

      }
    }
  }




  async deletesInIngredients(uid) {
    var ingredients = await this.ingredientsServices.getIngredientsBasic(this.globals.restaurant_uid);
    var provider = await this.providersServices.getNoProvider(this.globals.restaurant_uid);

    for (let ingredient of ingredients) {
      const index = ingredient.providers.findIndex(doc => doc.uid === uid);//buscar proveedor a eliminar en proveedores de ingrediente
      var price_static = ingredient.price_static;//init
      var provider_static = ingredient.provider_static;//init

      if (index != -1) {
        if (ingredient.providers[index].default) {//si provider que queremos eliminar es default
          var _provider_deleted = ingredient.providers[index];
          ingredient.providers.splice(index, 1);//eliminar proveedor
          const i = ingredient.providers.findIndex(doc => doc.uid === provider.UID);//buscar no_provider  en proveedores de ingrediente
          if (i != -1) {//si existe no_provider marcar default
            ingredient.providers[i].default = true;
            price_static = ingredient.providers[i].price_static;
            provider_static = ingredient.providers[i].name_static;

          } else {//no existe no_provider crear y marcar default
            price_static = _provider_deleted.price_static
            provider_static = provider.name;
            //push no_provider
            ingredient.providers.push({
              'default': true,
              'name_static': provider_static,
              'price_static': price_static,
              'pricetotal_static': _provider_deleted.pricetotal_static,
              'tax_static': _provider_deleted.tax_static,
              'uid': provider.UID,
              'updated_at': new Date(),
            });
          }
        } else {//provider que eliminamos no es default
          ingredient.providers.splice(index, 1);//eliminar proveedor
        }
        //actualizar ingrediente
        this.ingredientsServices.afs.collection('ingredients').doc(ingredient.UID).update({
          'providers': ingredient.providers,
          'provider_static': provider_static,
          'price_static': price_static,
        }).then(() => {
        });
      }
    }
  }

  async deletesInProducts(uid) {
    var products = await this.productsServices.getProductsBasic(this.globals.restaurant_uid);
    var provider = await this.providersServices.getNoProvider(this.globals.restaurant_uid);

    for (let product of products) {
      const index = product.providers.findIndex(doc => doc.uid === uid);
      var price_static = product.price_static;//init
      var provider_static = product.provider_static;//init

      if (index != -1) {
        if (product.providers[index].default) {//si provider que queremos eliminar es default
          var _provider_deleted = product.providers[index];
          product.providers.splice(index, 1);//eliminar proveedor
          const i = product.providers.findIndex(doc => doc.uid === provider.UID);
          if (i != -1) {//si existe no_provider marcar default
            product.providers[i].default = true;
            price_static = product.providers[i].price_static;
            provider_static = product.providers[i].name_static;
          } else {//no existe no_provider crear y marcar default
            price_static = _provider_deleted.price_static
            provider_static = provider.name;
            //push no_provider
            product.providers.push({
              'default': true,
              'name_static': provider_static,
              'price_static': price_static,
              'pricetotal_static': _provider_deleted.pricetotal_static,
              'tax_static': _provider_deleted.tax_static,
              'uid': provider.UID,
              'updated_at': new Date(),
            });
          }
        } else {//provider que eliminamos no es default
          product.providers.splice(index, 1);//eliminar proveedor
        }
        //actualizar ingrediente
        this.ingredientsServices.afs.collection('products').doc(product.UID).update({
          'providers': product.providers,
          'provider_static': provider_static,
          'price_static': price_static,
        }).then(() => {
        });
      }
    }
  }

  loading: any = null;
  presentLoading() {
    if (!this.loading) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('instant-actualizando valores')
      });
      this.loading.present();
    }
  }

  dissmisLoading() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/services/statics.ts